import { JSX } from "solid-js";
import { useTelescopeContext } from "@hubble/telescope";
import { usePaymentLoaderContext } from "../context/payment_loader_context";

export function ExpiredState(): JSX.Element {
  const { components } = useTelescopeContext();
  const { handleTryAgain } = usePaymentLoaderContext();

  return (
    <div class="flex h-[430px] w-full flex-col items-center justify-center gap-4">
      <div class="flex flex-col items-center gap-3">
        {/* Error icon - red circle with exclamation mark */}
        <div class="flex size-9 items-center justify-center rounded-full bg-error-base">
          <div class="flex flex-col items-center">
            <div class="h-[11px] w-0.5 rounded-full bg-white" />
            <div class="mt-1 size-[3px] rounded-full bg-white" />
          </div>
        </div>

        {/* Error text */}
        <p class="text-center text-title-4-semi-bold tracking-[-0.3px] text-error-base">
          QR code expired
        </p>
      </div>

      {/* Try again button */}
      <components.Button
        text="Try again"
        variant="secondary"
        style="neutral"
        size={40}
        onClick={handleTryAgain}
      />
    </div>
  );
}
